import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ProjectHero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return <section data-section-id="25197" id="hero-overview" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure_drone_hero.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-ring/30 to-transparent" />

      {}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        {}
        <h1 className={`font-default text-4xl font-extrabold text-white md:text-6xl lg:text-[64px] transition-all duration-1000 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        letterSpacing: "-0.02em"
      }}>
          Redefining Urban <span className="text-accent">Connectivity</span>
        </h1>

        {}
        <p className={`mt-6 max-w-2xl font-mono text-lg text-white/90 md:text-[20px] transition-all duration-1000 delay-300 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          Delivering resilient infrastructure through data-driven architectural futurism and precision engineering.
        </p>

        {}
        <div className={`mt-10 transition-all duration-1000 delay-500 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild className="h-auto rounded-none border-l-2 border-ring bg-secondary px-8 py-4 text-base font-medium text-secondary-foreground shadow-lg hover:bg-secondary/90">
            <Link to="/ProjectsPage">
              Explore Projects
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}